import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { IThirdPartyLineOfBusiness } from '@ruby/modules/third-party/models/third-party.interface';
import { selectThirdPartyContractState } from '@ruby/modules/third-party/store';
import { fromThirdPartyAuthorization, ThirdPartyAuthorizationActions } from '@ruby/modules/third-party/store/third-party-authorization.index';
import { fromThirdPartyCompanies } from '@ruby/modules/third-party/store/third-party-companies.index';
import { fromThirdPartyCore, ThirdPartyCoreActions } from '@ruby/modules/third-party/store/third-party-core.index';
import { ThirdPartyStepperActions } from '@ruby/modules/third-party/store/third-party-stepper.index';
import { ERole } from '@ruby/shared/enums/roles.enums';

@Component({
  selector: 'ng-third-party-done-container',
  template: `
    <ng-third-party-done *ngIf="(store$ | async) as store"
                         [customerCompany]="store.companies.customerCompany"
                         [providerCompany]="store.companies.providerCompany"
                         [selectedLOB]="selectedLOB"
                         [lineOfBusiness]="lineOfBusiness"
                         (cancel)="cancel()"
                         (accept)="accept()"
                         (selectedLob)="selectLineOfBusiness($event)">
    </ng-third-party-done>`
})
export class ThirdPartyDoneContainerComponent {
  selectedLOB?: string;
  lineOfBusiness!: Array<IThirdPartyLineOfBusiness>;
  store$: Observable<{
    core: fromThirdPartyCore.State;
    authorizations: fromThirdPartyAuthorization.State;
    companies: fromThirdPartyCompanies.State;
    contractId?: string;
  }>;

  constructor(private store: Store<fromThirdPartyCore.State>, private router: Router) {
    this.store$ = this.store.select(selectThirdPartyContractState).pipe(
      tap((st: {
        core: fromThirdPartyCore.State;
        authorizations: fromThirdPartyAuthorization.State;
        companies: fromThirdPartyCompanies.State;
      }) => {
        this.selectedLOB = st.core.loa?.lineOfBusiness;
        this.lineOfBusiness = st.authorizations.lob;
      })
    );
  }

  /**
   * Select Line Of Business
   *
   * @summary This function sets the selected line of business
   * @param $event: ERole
   * @returns void
   */
  selectLineOfBusiness($event: ERole): void {
    this.store.dispatch(ThirdPartyAuthorizationActions.setSelectedLOB({ data: $event }));
  }

  /**
   * Cancel
   *
   * @summary This function navigates to the 3PL grid and clean the stepper store
   * @returns void
   */
  cancel(): void {
    this.store.dispatch(ThirdPartyCoreActions.hardReset({ data: true }));
    this.router.navigate(['home/third-party-providers']);
  }

  /**
   * Accept
   *
   * @summary This function sets the selected Line of Business and go back to step 2
   * @returns void
   */
  accept(): void {
    this.store.dispatch(ThirdPartyCoreActions.hardReset({ data: false }));
    this.store.dispatch(ThirdPartyStepperActions.setNewLOA({ data: true }));
    this.store.dispatch(ThirdPartyStepperActions.enableDone({ data: false }));
    this.store.dispatch(ThirdPartyStepperActions.setStepIndex({ data: 2 }));
  }
}
